var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMusicPlayerNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.585 15.933L10.9854 9.33331L8.84151 11.4772L13.2945 15.9302L8.78512 20.4396L10.929 22.5834L15.4384 18.074L15.4412 18.0768L17.585 15.933Z",
    fill: "#212624",
    style: {
      mixBlendMode: "multiply"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.333,
    y: 22.6666,
    width: 13.3333,
    height: 3.03184,
    transform: "rotate(-90 20.333 22.6666)",
    fill: "#212624"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMusicPlayerNext);
export default __webpack_public_path__ + "static/media/icon_music_player_next.6bfc5c99919e9eeb149d0dcc55c45d43.svg";
export { ForwardRef as ReactComponent };